// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-PageContainer-PageContainer-module__pageContainer";
var _2 = "webpack-components-shared-PageContainer-PageContainer-module__pageContent";
export { _1 as "pageContainer", _2 as "pageContent" }
